import * as yup from 'yup'

export const schemaCreateFeedback = yup.object().shape({
    process_feedback: yup.string().required(),
    process_feedback_status: yup.string().required(),
})
